import React from 'react'
import {Card, makeStyles} from '@material-ui/core'
import data from '../../Widgets/data'
import {isUndefined, isNull} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
const useStyles = makeStyles((theme) => ({
  widgetItem: {
		minHeight: 200,
    transition: '200ms all',
    border: '4px solid transparent',
    maxHeight: '300px',
    backgroundColor: '#09585C80', position: 'relative', overflow: 'hidden', 
    '&:hover': {
      cursor: 'pointer'
    }
  },
  widgetItemSelected: {
		minHeight: 200,
    transition: '200ms all',
    maxHeight: '300px',
    backgroundColor: '#09585C80', position: 'relative', overflow: 'hidden', 
    border: '4px solid rgb(68, 209, 194)',
    '&:hover': {
      cursor: 'pointer'
    }
  }
}));

function WidgetItem(props) {
  const [raised, setToggleRaised] = React.useState(false)
  const [Component, setComponent] = React.useState(null)
  const [selected, setSelected] = React.useState(false)

  React.useEffect(() => {
    setComponent(GetComponent())
  },[])
  
  const GetComponent = () => {
    let item = data.find(d => d.type === props._item.type)
    if(isUndefined(item)) return <><IntlMessages id="Invalid.type"/></>
    return <item.Component filterOptionsArr={[]} getIntervalTypeText={() => props.intl.formatMessage({ id: 'Calendar.Month' })} isFrom={1} getMainValueText={()=>''}/>
  }

  const handleSelectBox = () => {
    setSelected((state) => {
      let selected = !state

      if(selected) props.handleAddBlock(props._item)
      else props.handleRemoveBlock(props._item)

      return selected
    })
  }

  const classes = useStyles()
  return (
    <Card 
    className={!selected ? classes.widgetItem : classes.widgetItemSelected}
    onClick={handleSelectBox}
    onMouseOver={() => setToggleRaised(true)} 
    onMouseOut={() => setToggleRaised(false)} 
    raised={raised}>
      {!isNull(Component) && Component}
    </Card>
  )
}

export default injectIntl(WidgetItem);
